/**
 * Metric integrations linked to a client user's company, from /me/.
 *
 * The backend sends `{ ga4, search_console, seranking }` for single-client
 * users and a `{ client_id: {...} }` map for multi-client ones. Returns the
 * flags of `clientId`, or of the first company with any integration when no
 * client is selected, plus the id they belong to (null for single-client).
 */

const NONE = { ga4: false, search_console: false, seranking: false };

export const hasAnyIntegration = (flags) =>
  Boolean(flags?.ga4 || flags?.search_console || flags?.seranking);

export const getClientIntegrations = (user, clientId = null) => {
  if (!user || user.role !== "client") return { clientId: null, flags: NONE };

  const raw = user.integrations;
  if (!raw || typeof raw !== "object") return { clientId: null, flags: NONE };

  if (typeof raw.ga4 === "boolean") {
    return { clientId: null, flags: { ...NONE, ...raw } };
  }

  if (clientId !== null && clientId !== undefined) {
    const flags = raw[String(clientId)];
    return { clientId, flags: { ...NONE, ...(flags || {}) } };
  }

  const match = Object.entries(raw).find(([, flags]) => hasAnyIntegration(flags));
  return match
    ? { clientId: Number(match[0]), flags: { ...NONE, ...match[1] } }
    : { clientId: null, flags: NONE };
};
